module.exports = __webpack_public_path__ + "static/media/Cairo-Light.491011f9.ttf";